import { io, type Socket } from 'socket.io-client'

// Singleton socket: один TCP-коннект на всё приложение, события разводятся через комнаты.
// Лениво создаётся при первом обращении и переподключается с экспоненциальным backoff'ом.
let socket: Socket | null = null

function getBaseUrl(): string {
	// Vite env vars инжектятся через VITE_*. Падать здесь нельзя — отвалится app shell.
	const url = (import.meta.env.VITE_REALTIME_URL as string | undefined) ??
		(import.meta.env.VITE_API_URL as string | undefined) ??
		window.location.origin
	return url
}

function getToken(): string | null {
	// Auth-токен лежит в localStorage (используется apiSlice для REST-вызовов).
	// Для WS он же — нужен только при handshake.
	return localStorage.getItem('access_token')
}

export function getRealtimeSocket(): Socket {
	if (socket && socket.connected) return socket

	const token = getToken()
	// Socket.io path = '/realtime' (Caddy роутит этот префикс на gateway:WS_PORT,
	// см. RedisIoAdapter). Namespace default '/'. Без указания path клиент
	// постучится в '/socket.io/' который висит на main HTTP server, а там нет WS.
	socket = io(getBaseUrl(), {
		path: '/realtime',
		auth: { token },
		transports: ['websocket'],
		reconnection: true,
		reconnectionAttempts: Infinity,
		reconnectionDelay: 1000,
		reconnectionDelayMax: 10000
	})

	// Heartbeat для presence: продлевает TTL Redis-ключа на бекенде.
	const heartbeatId = setInterval(() => {
		if (socket?.connected) socket.emit('heartbeat')
	}, 30_000)

	socket.on('disconnect', () => {
		// Не разрываем интервал — он попробует послать heartbeat при реконнекте.
	})

	socket.on('connect_error', err => {
		// Молчим в консоли: NotificationsProvider покажет статус.
		if (import.meta.env.DEV) {
			console.warn('[realtime] connect_error', err.message)
		}
	})

	;(socket as Socket & { _heartbeatId?: NodeJS.Timeout })._heartbeatId =
		heartbeatId

	return socket
}

export function closeRealtimeSocket(): void {
	if (socket) {
		const id = (socket as Socket & { _heartbeatId?: NodeJS.Timeout })
			._heartbeatId
		if (id) clearInterval(id)
		socket.disconnect()
		socket = null
	}
}

export function refreshRealtimeAuth(): void {
	// Вызывается после refresh access_token. Простейший способ — реконнект,
	// потому что Socket.io не позволяет менять auth у активного коннекта.
	closeRealtimeSocket()
	getRealtimeSocket()
}
